let Layout = () => import("@/components/layout/index");

module.exports = [
	
	{
		path: "/",
		component: () => import('@/pages/index/index'),
		meta:{
			noAuth:true,
			front:true
		},
		hidden: true
	},
	
	{
		path: "/index/:subjectId",
		component: () => import('@/pages/index/index'),
		meta:{
			noAuth:true,
			front:true
		},
		hidden: true
	},
	
	{
		path: "/preview",
		component: () => import('@/pages/preview/preview'),
		meta:{
			noAuth:true,
			front:true
		},
		hidden: true
	},
	
	
	{
		path: "/login",
		component: require("@/pages-saas/login/login").default,
		meta:{
			noAuth:true
		},
		hidden: true
	},

	{
		path: "/saas",
		redirect: "/saas/works",
		hidden: true
	},
	
	
	{
		path: "/saas",
		component: Layout,
		children: [
			{
				path: "works",
				component:() => import('@/pages-saas/works/works'),
				meta: {
					title: '全景作品管理',
					icon: 'icon-vr'
				}
			}
		]
	},
	
	{
		path: "/saas",
		component: Layout,
		children: [
			{
				path: "category",
				component:() => import('@/pages-saas/category/category'),
				meta: {
					title: '作品分类管理',
					icon: 'icon-category'
				}
			}
		]
	},

	{
		path: "/saas",
		component: Layout,
		children: [
			{
				path: "comment",
				component:() => import('@/pages-saas/comment/comment'),
				meta: {
					title: '作品评论管理',
					icon: 'icon-comment'
				}
			}
		]
	},
	
	
	{
		path: "/saas",
		component: Layout,
		children: [
			{
				path: "info",
				component:() => import('@/pages-saas/info/info'),
				meta: {
					title: '基础信息管理',
					icon: 'icon-file'
				}
			}
		]
	},

	// {
	// 	path: "/saas",
	// 	component: Layout,
	// 	children: [
	// 		{
	// 			path: "task",
	// 			component:() => import('@/pages-saas/task/task'),
	// 			meta: {
	// 				title: '全景复拍上传',
	// 				icon: 'icon-task'
	// 			}
	// 		}
	// 	]
	// },
	
	{
		path: "/saas",
		component: Layout,
		children: [
			{
				path: "account",
				component:() => import('@/pages-saas/account/account'),
				meta: {
					title: '员工账号管理',
					icon: 'icon-account'
				}
			}
		]
	},

	
	
	{
		path: "/tour",
		component: require("@/pages-saas/tour/tour").default,
		hidden: true
	},
	
];
